import { Api } from "../../Utils/api"
import { RetAPI } from "../../Utils/Types"

export type Empresa = {
    razao: string,
    fantasia: string,
    tipoPessoa: string,
    documento: string,
    nome: string,
    logradouro: string,
    bairro: string,
    cep: string,
    numero: string,
    uf: string,
    cidade: string,
    email: string,

}

export const CadastroEmpresaService = {

    save: async (empresa: Empresa): Promise<RetAPI> => {

        const resp = await Api('Empresa/Cliente/Save', 'post', empresa)

        if (resp.data){
            console.log('resposta', resp)
            return {
                error: resp.data.error === "0",
                msg: resp.data.error === "1" ? resp.data.msg : ''
            }
        }

        return {
            error: false,
            msg: 'Nenhum retorno encontrado'
        }
    }

}